var map = {
	"./project/ang-mo-kio-ave1/01.jpg": "0ab4",
	"./project/ang-mo-kio-ave1/02.jpg": "3ce0",
	"./project/bannerimage/bannerimage-desktop.jpg": "934b",
	"./project/bannerimage/bannerimage.jpg": "ed31",
	"./project/changi-village/01.jpg": "391c",
	"./project/changi-village/01_bak.jpg": "1496",
	"./project/changi-village/02.jpg": "e34b",
	"./project/icons/cursor_360.svg": "6a45",
	"./project/icons/icon_360_black.svg": "ce56",
	"./project/icons/icon_360_white.svg": "b39e",
	"./project/icons/location.svg": "4031",
	"./project/japanese-cemetery/01.jpg": "edab",
	"./project/japanese-cemetery/02.jpg": "63ed",
	"./project/japanese-cemetery/03.jpg": "eaef",
	"./project/kranji-marshes/01.jpg": "b536",
	"./project/kranji-marshes/02.jpg": "d888",
	"./project/kranji-marshes/03.jpg": "f3ce",
	"./project/kranji-marshes/04.jpg": "9708",
	"./project/lower-pierce-reservoir/01.jpg": "6395",
	"./project/lower-pierce-reservoir/02.jpg": "81f0",
	"./project/pasir-ris-town/01.jpg": "d5c0",
	"./project/pasir-ris-town/02.jpg": "8cf5",
	"./template/image-background-header-desktop.jpg": "5c5b",
	"./template/image-background-header.jpg": "32e0",
	"./template/sample-image-desktop.png": "3100",
	"./template/sample-image.png": "da96",
	"./template/sample-logo.svg": "2bfb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";